/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CrCrProtocolsCreateCrRequest,
  CrCrProtocolsCreateCrResponse,
  CrCrProtocolsGetCrDetailRequest,
  CrCrProtocolsGetCrDetailResponse,
  CrCrProtocolsGetCrListRequest,
  CrCrProtocolsGetCrListResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Cr<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Cr
   * @name ListCreate
   * @request POST:/cr/list
   */
  listCreate = (data: CrCrProtocolsGetCrListRequest, params: RequestParams = {}) =>
    this.http.request<CrCrProtocolsGetCrListResponse, any>({
      path: `/cr/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Cr
   * @name DetailCreate
   * @request POST:/cr/detail
   */
  detailCreate = (data: CrCrProtocolsGetCrDetailRequest, params: RequestParams = {}) =>
    this.http.request<CrCrProtocolsGetCrDetailResponse, any>({
      path: `/cr/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Cr
   * @name CreateCreate
   * @request POST:/cr/create
   */
  createCreate = (data: CrCrProtocolsCreateCrRequest, params: RequestParams = {}) =>
    this.http.request<CrCrProtocolsCreateCrResponse, any>({
      path: `/cr/create`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
